/**
 * Лічильник пошти в навігації: окремо від `api.ts`, бо він у першому екрані, а решта запитів кабінету
 * туди не потрібна (бюджет, performance-budget.md).
 */
import type { MailboxListResponse } from '@clientline/contracts/mail';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../platform/api.ts';
import { useStreamOpen } from '../../platform/events.ts';
import { queryPolicy } from '../../platform/query-policy.ts';

export const MINE = '/api/v1/mail/mailboxes';
export const MAILBOXES_KEY = ['mail', 'mailboxes'] as const;

/** Опитування кабінету, коли потоку подій немає. */
const MAIL_POLL_MS = 60_000;
/** Страхове опитування кабінету при живому потоці. */
const MAIL_POLL_LIVE_MS = 5 * 60_000;

export const fetchMyMailboxes = (signal?: AbortSignal) =>
  api<MailboxListResponse>('GET', MINE, signal ? { signal } : {}).then((r) => r.items);

/**
 * Опитування кабінету: без потоку подій — раз на 60 с; з потоком зміни приносить
 * `mail.mailbox_changed`, а рідке опитування страхує сигнал, якого сесія не дала (рев'ю ML-W1,
 * Архітектор S1). Хук підписаний на стан потоку: обрив вмикає часте опитування одразу (S2).
 */
export const useMailPoll = () => (useStreamOpen() ? MAIL_POLL_LIVE_MS : MAIL_POLL_MS);

/** Лічильник у навігації: непрочитані «Вхідні» всіх моїх скриньок. */
export function useMailUnread(enabled: boolean): number {
  const poll = useMailPoll();
  const { data } = useQuery({
    queryKey: MAILBOXES_KEY,
    queryFn: ({ signal }) => fetchMyMailboxes(signal),
    enabled,
    ...queryPolicy.counts,
    refetchInterval: poll,
  });
  return (data ?? []).reduce((sum, box) => sum + box.unread, 0);
}
